import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { SnmpObjectConfigurationDTO } from 'src/app/model/configuration/snmp/snmp-object-configuration-dto';

@Component({
  selector: 'app-snmp-object-configuration-dialog',
  templateUrl: './snmp-object-configuration-dialog.component.html',
  styleUrls: ['./snmp-object-configuration-dialog.component.scss']
})
export class SnmpObjectConfigurationDialogComponent implements OnInit {
  form: FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { item: SnmpObjectConfigurationDTO },
    public dialogRef: MatDialogRef<SnmpObjectConfigurationDialogComponent>,
    private readonly fb: FormBuilder
  ) {
    const item = data?.item || {};

    this.form = this.fb.group({
      name: [item.name || '', Validators.required, this.requiredAsyncValidator],
      oid: [item.oid || '', Validators.required, this.requiredAsyncValidator, Validators.pattern('^\d+(\.\d+)+$')],
    });
  }

  ngOnInit(): void {
    if (this.data?.item) {
      if (this.data.item.oid) {
        this.form.get('oid')?.setValue(this.data.item.oid);
      }

      if (this.data.item.name) {
        this.form.get('name')?.setValue(this.data.item.name);
      }
    } else {
      console.error('No se recibió data o item está vacío');
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  save(): void {
    if (this.form.valid) {
      this.dialogRef.close(this.form.value);
    }
  }

  requiredAsyncValidator(control: AbstractControl): Observable<ValidationErrors | null> {
    return new Observable(observer => {
      // Simulamos una verificación asíncrona
      setTimeout(() => {
        // Comprobar si el valor es válido, ya sea una cadena no vacía o un número distinto de 0
        if (control.value != null && (typeof control.value === 'string' ? control.value.trim() !== '' : control.value > 0)) {
          observer.next(null); // El campo es válido
        } else {
          observer.next({ required: true }); // El campo es obligatorio
        }
        observer.complete();
      }, 1000); // Simula un retraso de 1 segundo
    });
  }
}
